<template>
  <div>
    <div
      v-if="videoId"
      :id="iframeId"
    />
  </div>
</template>

<script>
export default {
  props: {
    videoId: {
      type: String,
      default: ''
    },
    playerWidth: {
      type: Number,
      default: undefined
    },
    playerHeight: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      iframeId: 'my-youtube-player-' + this._uid
    }
  },
  mounted() {
    this.iframe = document.getElementById(this.iframeId)
    if (!window.youtubeApiLoaded) {
      window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady
      window.loadScript('https://www.youtube.com/iframe_api', () => {
        window.youtubeApiLoaded = true
      })
    } else {
      this.onYouTubeIframeAPIReady()
    }
  },
  methods: {
    onYouTubeIframeAPIReady() {
      const self = this
      // eslint-disable-next-line no-undef
      this.player = new YT.Player(self.iframeId, {
        height: self.playerHeight,
        width: self.playerWidth,
        videoId: self.videoId,
        playerVars: {
          modestbranding: 1
        },
        events: {
          onReady: self.onPlayerReady,
          onStateChange: self.onPlayerStateChange
        }
      })
      $('#' + self.iframeId).attr('video-type', 'video_type.youtube')
    },
    onPlayerReady(event) {
      event.target.playVideo()
    },
    onPlayerStateChange(event) {
      if (event && event.data === 0) {
        this.$emit('ended')
      }
    },
    getVideoUrl() {
      const videoId = this.videoId
      if (videoId.startsWith('http')) {
        return videoId
      }
      return 'https://www.youtube.com/embed/' + videoId + '?modestbranding=0'
    }
  }
}
</script>
